import { useTranslation } from "react-i18next";
import Link from "next/link";

import TextButton from "../../button/TextButton";
import Styled from "./index.styles";

export default function BoardVideoItem({
  title,
  category,
  videoUrl,
  href,
  className,
}: {
  title: string;
  category: React.ReactNode;
  videoUrl: string;
  href: string;
  className?: string;
}) {
  const { t } = useTranslation(["sds-v1"]);

  return (
    <Styled.container
      className={`${className ? className : ""} board-video-item`}
    >
      <Link href={href}>
        <a>
          <div className="video-thumbnail">
            <em>{title}</em>
            <strong>{category}</strong>
          </div>

          <div className="video-item-info">
            <h4>{category}</h4>
            <h5>{title}</h5>

            <TextButton
              label={t("sds-v1:BoardVideoItem_확인하기")}
              size="14px"
              theme="withIcon"
              icon="arrowRight"
            />
          </div>
        </a>
      </Link>
    </Styled.container>
  );
}
